import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCrossCircleBox32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCrossCircleBox32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M25 7H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M7 5a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4zm9 16a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0 2a7 7 0 1 0 0-14 7 7 0 0 0 0 14m2.454-9.457a1 1 0 0 1 0 1.414L17.413 16l1.041 1.042a1 1 0 0 1-1.414 1.415L16 17.414l-1.042 1.042a1 1 0 1 1-1.414-1.415L14.585 16l-1.042-1.042a1 1 0 0 1 1.414-1.414l1.042 1.042 1.041-1.042a1 1 0 0 1 1.414 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCrossCircleBox32);
